module.exports = __webpack_public_path__ + "img/promo.a3c9ac9d.jpg";